import { notification } from 'antd'
import apiClient from '../index'

export const getEmpPunchReport = async (
  month,
  year,
  selectedEmployeeId,
  skip = 0,
  limit = 10,
  locationId,
) => {
  try {
    const params = {}

    if (month) params.month = month
    if (year) params.year = year
    if (selectedEmployeeId) params.employeeId = selectedEmployeeId
    if (locationId) params.locationId = locationId

    params.skip = skip
    params.limit = limit

    const response = await apiClient.get('/dashboard/biometric/employee/punch-report', { params })

    return response?.data
  } catch (error) {
    notification.error({
      message:
        error?.response?.data?.message ||
        error?.message ||
        'Failed to fetch employee punching report',
    })
    return null
  }
}
